import { TrezorDerivationPathType } from '../types.js';
import TrezorBase from './Base.js';
export class TrezorBip32 extends TrezorBase {
    constructor(args) {
        super({
            ...args,
            derivationPathType: TrezorDerivationPathType.Bip32,
        });
    }
}
